export const getLoadingPageUrl = (
  platform: string,
  direction: string,
): string => {
  return `/loading?platform=${platform}&direction=${direction}`;
};
